<template>
  <el-card  style="width: 2310px">
 
  <el-row>
    <el-col  :span="2">
      <el-select v-model="cxtype" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>  
      <el-col :span="4">
        <el-input v-model="keyword" placeholder="请输入内容">
          <el-button slot="append" icon="el-icon-search" @click="getlist(1)"></el-button>
        </el-input>
      </el-col>
  </el-row>
<el-table :data="tableData" border style="width: 100%" size="small"  :row-class-name="tableRowClassName" stripe>
      <el-table-column fixed="left" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
          <el-button @click="huifuClick(scope.row)" type="text" size="small">回复</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="xhid" label="序号" width="50" height="250"></el-table-column>
      <el-table-column prop="diyid" label="编号" width="85"></el-table-column>
      <el-table-column prop="cxid" label="查询id" width="80"></el-table-column>
      <el-table-column prop="createTime" label="举报时间" width="100"></el-table-column>
      <el-table-column prop="bjbdw" label="举报单位" width="170"></el-table-column>
      <el-table-column prop="bjbbm" label="举报部门" width="100"></el-table-column>
      <el-table-column prop="nr" label="举报内容" width="190" show-overflow-tooltip></el-table-column>
      <el-table-column prop="jbrxm" label="举报人姓名" width="100"></el-table-column>
      <el-table-column prop="jbrdh" label="举报人电话" width="120"></el-table-column>      
      <el-table-column prop="hfnr" label="回复" width="190" show-overflow-tooltip></el-table-column>
      <el-table-column prop="hftime1" label="回复时间" width="150"></el-table-column>
      <el-table-column prop="hfnr2" label="回复二" width="190" show-overflow-tooltip></el-table-column>
      <el-table-column prop="hftime2" label="回复二时间" width="150"></el-table-column>
      <el-table-column prop="hfnr3" label="回复三" width="190" show-overflow-tooltip></el-table-column>
      <el-table-column prop="hftime3" label="回复三时间" width="150"></el-table-column>
      <el-table-column prop="cxtime" label="查询时间" width="150"></el-table-column>

    </el-table>
    <el-pagination
      @size-change="getlist"
      @current-change="getlist"
      background
      layout="prev, pager, next"
      :current-page="currentPage"
      :total="listtotal"
    ></el-pagination>
    <el-dialog title="举报查看" :visible.sync="dialogFormVisible" width="85%" top="1%">
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>被举报单位</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入内容" v-model="bjbdw" :readonly="true"></el-input>
        </el-col>

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>被举报部门</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="bjbbm" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>编号</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="diyid"  :readonly="true"></el-input>
        </el-col>        
      </el-row>
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报标题</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="nrbt" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报内容</span>
        </el-col>
        <el-col :span="13">
          <el-input
            placeholder=" "
            v-model="nr"
            :readonly="true"
            :autosize="{ minRows: 1, maxRows: 6}"
            type="textarea"
          ></el-input>
        </el-col>        
      </el-row>
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>上传附件</span>
        </el-col>
        <el-col :span="21">
          <el-upload
            disabled
            :file-list="fj1"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
          ></el-upload>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 6px;">

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者公司</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrgs" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者部门</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrbm" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者姓名</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrxm" :readonly="true"></el-input>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 6px;">

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者电话</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrdh" :readonly="true"></el-input>
        </el-col>

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者岗位</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrgw" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者身份</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrsf" :readonly="true"></el-input>
        </el-col>


      </el-row>

     <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>回复内容</span>
        </el-col>
        <el-col :span="13">
          <el-input
            placeholder=" "
            v-model="hfnr"
             :readonly="true"
            :autosize="{ minRows: 4, maxRows: 10}"
            type="textarea"
          ></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>回复二</span>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder=" "
            v-model="hfnr2"
            :readonly="true"
            :autosize="{ minRows: 4, maxRows: 10}"
            type="textarea"
          ></el-input>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>回复三</span>
        </el-col>
        <el-col :span="13">
          <el-input
            placeholder=" "
            v-model="hfnr3"
             :readonly="true"
            :autosize="{ minRows: 1, maxRows: 10}"
            type="textarea"
          ></el-input>
        </el-col>
      </el-row>         
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="filesToRar()">下 载</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="举报回复" :visible.sync="hfVisible" width="75%" top="1%">
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>被举报单位</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入内容" v-model="bjbdw" :readonly="true"></el-input>
        </el-col>

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>被举报部门</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="bjbbm" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>编号</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="diyid" ></el-input>
        </el-col>        
      </el-row>
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报标题</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="nrbt" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报内容</span>
        </el-col>
        <el-col :span="13">
          <el-input
            placeholder=" "
            v-model="nr"
            :readonly="true"
            :autosize="{ minRows: 1, maxRows: 6}"
            type="textarea"
          ></el-input>
        </el-col>        
      </el-row>
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>上传附件</span>
        </el-col>
        <el-col :span="21">
          <el-upload
            disabled
            :file-list="fj1"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
          ></el-upload>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 6px;">

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者公司</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrgs" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者部门</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrbm" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者姓名</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrxm" :readonly="true"></el-input>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 6px;">

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者电话</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrdh" :readonly="true"></el-input>
        </el-col>

        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者岗位</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrgw" :readonly="true"></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>举报者身份</span>
        </el-col>
        <el-col :span="5">
          <el-input placeholder=" " v-model="jbrsf" :readonly="true"></el-input>
        </el-col>
      </el-row>

     <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>回复内容</span>
        </el-col>
        <el-col :span="13">
          <el-input
            placeholder=" "
            v-model="hfnr"
             
            :autosize="{ minRows: 4, maxRows: 10}"
            type="textarea"
          ></el-input>
        </el-col>
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>回复二</span>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder=" "
            v-model="hfnr2"
            
            :autosize="{ minRows: 4, maxRows: 10}"
            type="textarea"
          ></el-input>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 6px;">
        <el-col :span="3" style="line-height: 40px;text-align: center;">
          <span>回复三</span>
        </el-col>
        <el-col :span="13">
          <el-input
            placeholder=" "
            v-model="hfnr3"
             
            :autosize="{ minRows: 1, maxRows: 10}"
            type="textarea"
          ></el-input>
        </el-col>
      </el-row>            
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="filesToRar()">下 载</el-button>
        <el-button @click="hfVisible = false">取 消</el-button>
        <el-button type="primary" @click="hftj()">提 交</el-button>
        <el-button type="warning" @click="hftjqr()">结 案</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showimg" width="50%" top="2%">
      <img width="100%" :src="showimgurl" alt />
    </el-dialog>
  </el-card>
</template>

<script>
import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  methods: {
    async handleClick(row) {
      this.dialogFormVisible = true;
      const { data: res } = await this.$http.post("/cxjb", {
        cxid: row.cxid,
        ht:'1',
      });
      if (res.status !== 0) {
        return;
      }
      this.cxid = res.data.cxid;
      this.xhid = res.data.xhid;
      this.diyid = res.data.diyid;      
      this.bjbdw = res.data.bjbdw;
      this.bjbbm = res.data.bjbbm;
      this.nr = res.data.nr;
      this.nrbt = res.data.nrbt;
      this.hfnr = res.data.hfnr;
      this.hftime1 = res.data.hftime1;
      this.hftime2 = res.data.hftime2;
      this.hftime3 = res.data.hftime3;
      this.hfnr2 = res.data.hfnr2;
      this.hfnr3 = res.data.hfnr3;      
      this.jbrxm = res.data.jbrxm;
      this.jbrdh = res.data.jbrdh;
      this.jbrgs = res.data.jbrgs;
      this.jbrbm = res.data.jbrbm;
      this.jbrgw = res.data.jbrgw;
      this.jbrsf = res.data.jbrsf;
      this.fj1 = JSON.parse(res.data.fj1);
    },
    async huifuClick(row) {
      this.hfVisible = true;
      const { data: res } = await this.$http.post("/cxjb", {
        cxid: row.cxid,
        ht:'1',
      });
      if (res.status !== 0) {
        return;
      }
      this.cxid = res.data.cxid;
      this.diyid = res.data.diyid;      
      this.bjbdw = res.data.bjbdw;
      this.bjbbm = res.data.bjbbm;
      this.nr = res.data.nr;
      this.nrbt = res.data.nrbt;
      this.hfnr = res.data.hfnr;
      this.hfnr2 = res.data.hfnr2;
      this.hfnr3 = res.data.hfnr3;      
      this.jbrxm = res.data.jbrxm;
      this.jbrdh = res.data.jbrdh;
      this.jbrgs = res.data.jbrgs;
      this.jbrbm = res.data.jbrbm;
      this.jbrgw = res.data.jbrgw;
      this.jbrsf = res.data.jbrsf;
      this.fj1 = JSON.parse(res.data.fj1);
    },
    async hftj(){
      if(!this.hfnr && !this.diyid){
         this.$message.warning("请填写回复内容！");
         return;
      } 
       const { data: res } = await this.$http.post("/tjhf", {
        cxid: this.cxid,
        hfnr: this.hfnr,
        hfnr2: this.hfnr2,
        hfnr3: this.hfnr3,
        diyid: this.diyid,
      });
      if(1==1){
        this.$message.success("提交 成功！");
        this.hfVisible = false;
        this.getlist(1)
        /*for(var i in this.tableData){
          if(this.tableData[i].cxid==this.cxid){
            this.tableData[i].hfnr= this.hfnr;
          }
        }*/
        return;
      }
    },
    async hftjqr(){

      const { data: res } = await this.$http.post("/tjhfqr", {
        cxid: this.cxid,
        hfnr: this.hfnr,
      });
      if (1==1) {
        this.$message.success("结案成功！");
        this.hfVisible = false;
        this.getlist(1)
        return;
      }
    },    
    async getlist(currentPage) {
      this.currentPage = currentPage;
      const { data: res } = await this.$http.post("/jblist", {
        keyword: this.keyword,
        hf: 1,
        cxtype: this.cxtype,
        page: currentPage,
      });
      if (res.status !== 0) {
        return;
      }
      for (var i in res.data.rows) {
        res.data.rows[i].createTime = res.data.rows[i].createTime
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      }
      this.tableData = res.data.rows;
      this.listtotal = res.data.count;
      console.log(res);
    },
    filesToRar() {
        let _this = this;
        let zip = new JSZip();
        let cache = {};
        let promises = [];
        let i = 0;
        var arrImages = this.fj1;
        var filename = this.cxid+'.zip'
        arrImages.forEach((item)=>{
            var promise = _this.getImgArrayBuffer(item.url).then(data => {
                i++;
                const arr_name = item.url.split("/")
                let name = arr_name[arr_name.length - 1]
                // 下载文件, 并存成ArrayBuffer对象(blob)
                zip.file(name, data, { binary: true }); // 逐个添加文件
                cache[name] = data;
            });
            promises.push(promise);
        })
        Promise.all(promises).then(() => {
            zip.generateAsync({ type: "blob" }).then(content => {
                // 生成二进制流
                FileSaver.saveAs(content, filename); // 利用file-saver保存文件  自定义文件名
            });
        })
        .catch(res=>{
            console.log("压缩失败")
        });
    },

    async getImgArrayBuffer(url){
        return new Promise((resolve, reject) => {
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.open("GET", url, true);
            xmlhttp.responseType = "blob";
            xmlhttp.onload = function () {
                if (this.status == 200) {
                    resolve(this.response);
                }else{
                    reject(this.status);
                }
            }
            xmlhttp.send();
        });
    },    
    handlePictureCardPreview(file) {
      this.showimgurl = file.url;
      this.showimg = true;
    },
  },
  created() {
    this.getlist(1);
  },
  data() {
    return {
      keyword: "",
      tableData: [],
      currentPage: 1, //初始页
      pagesize: 10, //    每页的数据
      listtotal: 0,
      dialogFormVisible: false,
      hfVisible: false,
      bjbdw: "",
      bjbbm: "",
      nr: "",
      nrbt: "",
      hfnr: "",
      hfnr2: "",
      hfnr3: "",     
      jbrxm: "",
      jbrdh: "",
      jbrgs: "",
      jbrbm: "",
      jbrgw: "",
      jbrsf: "",
      fj1: [],
      cxid: "",
      xhid: "",
      diyid: "",    
      showimgurl: "",
      showimg: false,
        options: [{
          value: '',
          label: ''
        },{
          value: '1',
          label: '未回复'
        }, {
          value: '2',
          label: '已回复'
        }],
        cxtype: ''
    };
  },
};
</script>
<style lang="less" >
 .el-tooltip__popper {
    max-width: 600px!important;  //宽度可根据自己需要进行设置 
  }
</style>  


// WEBPACK FOOTER //
// src/components/user/jbhf.vue